var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createComponentOverrides } from '../theme/create-component-overrides';
export var createMuiTypographyOverrides = createComponentOverrides(function (_a) {
    var typography = _a.typography;
    return ({
        defaultProps: {
            variant: 'body2',
        },
        variants: [
            {
                props: { variant: 'code1' },
                style: __assign({}, typography.code1),
            },
            {
                props: { variant: 'code2' },
                style: __assign({}, typography.code2),
            },
        ],
    });
});
